export default "__VITE_ASSET__9sxS29Ko__"